import React from 'react';

function ErrorBoundary({ children }) {
  const [error, setError] = React.useState(null);

  const handleError = (error) => {
    setError(error);
  };

  React.useEffect(() => {
    const handleWindowError = (event) => {
      handleError(event.error);
    };

    window.addEventListener('error', handleWindowError);

    return () => {
      window.removeEventListener('error', handleWindowError);
    };
  }, []);

  if (error) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <div style={{ textAlign: 'center' }}>
          <h1>Oops!</h1>
          <p>Something went wrong:</p>
          <p>{error.message}</p>
        </div>
      </div>
    );
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default ErrorBoundary;
